import React, { FC, HTMLAttributes } from 'react';
import { PaddingType } from '../../definitions';
import Loader from '../../elements/Loader';
import styles from './styles.module.scss';

interface SegmentProps extends HTMLAttributes<HTMLDivElement> {
    card?: boolean,
    className?: string,
    isLoading?: boolean,
    padding?: PaddingType,
    shadow?: boolean,
}

const Segment: FC<SegmentProps> = ({
    children,
    card,
    className,
    isLoading,
    padding,
    shadow,
    ...props
}): JSX.Element => {
    return (
        <div
            className={[
                styles.base,
                card && styles.card,
                padding && styles[`${padding}Padding`],
                shadow && styles.shadow,
                className,
            ].join(' ')}
            {...props}
        >
            {isLoading && <Loader card={card} />}
            {children}
        </div>
    );
}

export default Segment;
